//Al pasar el icono pasarlo con esta clase aria-hidden="true" className="h-5 w-5 text-gray-400"
import { FC, Fragment } from "react";
import { ExclamationCircleIcon } from "@heroicons/react/20/solid";

type option = {
  id: string | number;
  text: string;
};

export type InputDropDownSpanProps = {
  label: string;
  labelSelect?: string;
  id?: string;
  idSelect?: string;
  name?: string;
  nameSelect?: string;
  type: React.HTMLInputTypeAttribute;
  placeholder?: string;
  options: option[];
  onSelectChange: (event: React.ChangeEventHandler<HTMLSelectElement>) => void;
  onChange: any;
  value: any;
  selectValue: any;
  span?: string;
  error?: boolean;
  textError?: string;
  errorSpan?: boolean;
  textErrorSpan?: string;
};

export const InputDropDownSpan: FC<InputDropDownSpanProps> = ({
  label,
  id,
  name,
  type,
  placeholder,
  idSelect,
  labelSelect,
  nameSelect,
  options,
  onSelectChange,
  onChange,
  value,
  selectValue,
  span,
  error,
  textError,
  errorSpan,
  textErrorSpan,
}) => {
  return (
    <Fragment>
      <div>
        <div className="flex justify-between">
          <label
            htmlFor={id}
            className="block text-sm font-medium leading-6 text-gray-900"
          >
            {label}
          </label>
          <span className={`text-sm leading-6 text-gray-500`}>{span}</span>
        </div>

        <div className="relative rounded-md shadow-sm flex gap-2">
          <input
            id={id}
            name={name}
            type={type}
            placeholder={placeholder}
            onChange={onChange}
            value={value}
            //className="block w-full rounded-md border-0 py-1.5 pr-20 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary-600 sm:text-sm sm:leading-6"
            className={`px-2 block w-full rounded-md border-0 py-1.5 text-gray-400 shadow-sm ring-1 ring-inset ${
              error === true
                ? "ring-red-300 placeholder:text-red-300"
                : "ring-gray-300 placeholder:text-gray-400"
            } focus:ring-2 focus:ring-inset ${
              error === true ? "focus:ring-red-500" : "focus:ring-primary"
            } disabled:cursor-not-allowed disabled:bg-gray-100 disabled:text-gray-500 disabled:ring-gray-200 sm:text-sm sm:leading-6`}
          />
          <div className="flex items-center w-[40%] md:w-1/5">
            <label htmlFor={idSelect} className="sr-only">
              {labelSelect}
            </label>
            <select
              onChange={onSelectChange}
              id={idSelect}
              name={nameSelect}
              value={selectValue}
              defaultValue={selectValue}
              //className={`h-full rounded-md border-0 bg-transparent py-0 pl-2 pr-7 text-gray-500 focus:ring-2 focus:ring-inset focus:ring-primary-600 sm:text-sm ${
              className={`px-2 block w-full rounded-md border-0 py-1.5 text-gray-400 shadow-sm ring-1 ring-inset ${
                errorSpan === true
                  ? "ring-red-300 placeholder:text-red-300"
                  : "ring-gray-300 placeholder:text-gray-400"
              } focus:ring-2 focus:ring-inset ${
                errorSpan === true ? "focus:ring-red-500" : "focus:ring-primary"
              } disabled:cursor-not-allowed disabled:bg-gray-100 disabled:text-gray-500 disabled:ring-gray-200 sm:text-sm sm:leading-6`}

              //className=""
            >
              {options.map((option) => {
                return <option value={option.id}>{option.text}</option>;
              })}
            </select>
          </div>

          {error ? (
            <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
              <ExclamationCircleIcon
                aria-hidden="true"
                className="h-5 w-5 text-red-500"
              />
            </div>
          ) : (
            <></>
          )}
        </div>

        {error ? (
          <>
            <p className={`mt-1 text-sm text-red-600`}>{textError}</p>
          </>
        ) : (
          <></>
        )}
      </div>
    </Fragment>
  );
};
